export default __webpack_public_path__ + "media/images/images_v2/shde-right-7898d672de47ce038b3262f566f818f0.png";